import { render, staticRenderFns } from "./FeatureIconTypography.vue?vue&type=template&id=4f760e5a&scoped=true"
import script from "./FeatureIconTypography.vue?vue&type=script&lang=js"
export * from "./FeatureIconTypography.vue?vue&type=script&lang=js"
import style0 from "./FeatureIconTypography.vue?vue&type=style&index=0&id=4f760e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f760e5a",
  null
  
)

export default component.exports